
<template>
    <BTable :items="items"    class="cursor-pointer"    @row-clicked="onRowClicked" :fields="fields" striped show-empty >
        <template #row-details="row">
            <BCard >
                <div v-html="row.item.body"></div>
            </BCard>
        </template>
    </BTable>
</template>

<script>

import {
    BOverlay,
    BTable,
    BCard
} from 'bootstrap-vue-next';

export default {
    name: "tender_history",
    props : {
        tender: {
            type: Object,
            required: true
        }
    },
    components : {
        BTable,
        BCard
    },
    
    data() {
        return {
            items : [],
            is_load : false,
            fields : [
                { key: 'id', label: 'ID' },
                { key: 'added', label: 'Дата'  },
                { key: 'type', label: 'Тип'  },
                { key: 'email_from', label: 'Надіслав'  },
                { key: 'email_to', label: 'Адресат'  },
            ],
        }
    },
    
    created() {
        this.loadPositions()
    },
    
    methods : {
        
        onRowClicked(item, index) {
            item._showDetails = !item._showDetails
        },
        
        async loadPositions() {
            this.is_load = true;
            this.items = [];
            
            await api.get('/tenders/sales/tenders/' + parseInt(this.tender.id) + "/email/history").then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.items = data.data;
                }
            }).catch(response => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        }
    }
}
</script>


<style scoped>

</style>